import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  model,
  output,
  signal,
  untracked,
} from "@angular/core";
import { DocumentModel } from "../../models/document.model";
import { DocumentFacadeService } from "../../services/store/document-facade.service";
import { DocumentService } from "../../services/document.service";
import { FileViewerLocalComponent } from "../file-viewer-local/file-viewer-local.component";
import { FileUploaderComponent } from "../file-uploader/file-uploader.component";

@Component({
  selector: "vl-doc-local",
  standalone: true,
  imports: [FileViewerLocalComponent, FileUploaderComponent],
  templateUrl: "./doc-local.component.html",
  styleUrls: ["./doc-local.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocLocalComponent {
  facade = inject(DocumentFacadeService);
  documentService = inject(DocumentService);
  docId = input<string>();
  uploading = model(false);
  default = input(false);
  readOnly = input(false);
  height = input<string>("100px");
  width = input<string>("100px");
  maxHeight = input<string>();
  maxWidth = input<string>();
  showUploader = input(true);
  showActions = input(false);
  deactivateVisu = input(false);
  showPdf = input(false);

  uploadedDocId = output<string>();

  doc = signal<DocumentModel>(null);

  constructor() {
    effect(
      () => {
        const docId = this.docId();
        untracked(async () => {
          if (!docId) {
            this.doc.set(null);
            return;
          }
          // Retry : une navigation au bootstrap (ex : démarrage d'un tutoriel)
          // peut annuler la requête en vol ; sans retry, le docId ne changeant
          // pas, l'effect ne se rejoue jamais et le skeleton reste affiché.
          for (let attempt = 0; attempt < 3; attempt++) {
            try {
              const doc = await this.documentService.loadById(docId);
              if (doc) {
                this.doc.set(doc);
                return;
              }
            } catch {
              // requête annulée / erreur transitoire → on retente
            }
            await new Promise((r) => setTimeout(r, 1500));
          }
        });
      },
      { allowSignalWrites: true },
    );
  }

  async onUploadedDoc(doc: DocumentModel) {
    this.doc.set(doc);
    this.uploadedDocId.emit(doc.id);
  }

  async onDelete() {
    this.uploadedDocId.emit(null);
  }
}
